// extracted by mini-css-extract-plugin
module.exports = {"icon":"index_icon__3ISCZ","disableIcon":"index_disableIcon__2ZckL","adsorptionSelect":"index_adsorptionSelect__196MQ"};